
export class ReportFuel {
    dateStartChart:string;
    dateEndChart:string;
    sensorIdSearhChart:string;
    deviceIdSearhChart:any
}
